<template>
    <div class="ku-home">
        <van-pull-refresh
            v-model="refreshing"
            @refresh="onRefresh"
            :disabled="shopListC"
            :head-height="28"
            pulling-text=""
            loosing-text=""
            loading-text=""
            success-text=""
        >
            <div class="ku-shop">
                <van-button block type="primary" v-for="(item, index) in shopList" :key="index" @click="showMap(item)">
                    <div class="ku-line">
                        <span class="ku-b" v-if="item.to_status === 2 && item.ts > 0">{{ item.ts }}堂</span>
                        <span class="ku-b" v-if="item.to_status === 2 && item.wm > 0">外{{ item.wm }}</span>
                        <span class="ku-mid">
                            <span class="ku-n">{{ item.shop_name }}</span>
                            <span class="ku-d" v-if="item.to_status === 2">{{ item.price }}</span>
                        </span>
                        <span class="ku-p" v-if="item.to_status === 2">{{ item.total_price }}元</span>
                        <span class="ku-st" v-if="item.to_status !== 2">({{ item.to_status_text }})</span>
                    </div>
                    <label class="ss" v-if="item.to_status !== 2 && item.error_msg !== ''">{{ item.error_msg }}</label>
                </van-button>
            </div>

            <div class="ku-apply ku-home-apply" v-if="shopListC">
                <div class="word">
                    <span>非常重要的资金安全</span>
                    <label>由中国领先的持牌支付科技公司汇付天下提供支付结算，标准费率0.38%，T+1自动到账，安全又稳定。<br><font>不需要汇付支付的，可以自备pos，只能用收银及厨显功能</font></label>
                </div>
                <Apply />
            </div>
        </van-pull-refresh>

        <!-- footers outside pull-refresh so position:fixed is not trapped by transform -->
        <div class="ku-shop-s2" v-if="shopListC">
            <span @click="apply">老版申请</span>
        </div>
        <div class="ku-shop-s2" v-if="shopList.length > 0">
            <span @click="apply">申请新店铺</span>
            <span @click="tool_profit">净利润计算器</span>
        </div>

        <van-popup v-model="showPopup" class="csss">
            <van-loading type="spinner" />
        </van-popup>

    </div>
</template>

<script>
import Vue from 'vue'
import {Button, Image as VanImage, Popup, Loading, PullRefresh } from 'vant'
import {setShop, setCookie} from '@/utils/auth'

import Apply from '@/components/apply.vue'

Vue.use(Button).use(VanImage).use(Popup).use(Loading).use(PullRefresh);

export default {
    name: 'home',
    components: {
        Apply
    },
    data() {
        return {
            shopList: [],
            shopListC: false,
            shopCookieList: [],

            image1: require('../assets/1.jpg'),

            showPopup: false,
            refreshing: false
        }
    },
    mounted() {
        this.getShopList()
    },
    methods: {
        onRefresh() {
            this.loadShopList(true)
        },
        getShopList() {
            this.loadShopList(false)
        },
        loadShopList(quiet) {
            let _this = this
            if (!quiet) {
                _this.showPopup = true
                _this.shopList = []
            }
            this.$API.postShopList().then(res => {
                const list = (res && res.data) || []
                if (list.length > 0) {
                    _this.shopCookieList = []
                    _this.shopList = []
                    list.forEach(function (item) {
                        _this.shopList.push(item)
                        if (item.to_status === 2) {
                            _this.shopCookieList.push(item)
                        }
                    })
                    _this.shopListC = false
                    setCookie('shopInfo', JSON.stringify(_this.shopCookieList))
                } else {
                    _this.shopList = []
                    _this.shopListC = true
                }
            }).catch(function () {
                // keep existing list on quiet refresh failure
            }).then(function () {
                _this.showPopup = false
                _this.refreshing = false
            })
        },
        showMap(row) {
            if (row.to_status === 3) {
                this.$router.push('/apply?id=' + row.id)
            } else if (row.to_status === 2) {
                this.$router.push('/shop')
                setShop(row)
            }
        },
        apply() {
            this.$router.push('/apply')
        },
        tool_profit() {
            this.$router.push('/tool_profit')
        }
    }
}
</script>

<style lang="less" scoped>
@import "/src/styles/base";
.ku-home {
    height: auto;
    min-height: 100%;
    width: 100%;
    position: absolute;
    background: #50AFA7;

    .ku-shop {
        margin: 0 auto;

        .van-button {
            width: 92%;
            margin: 10px auto;
            border-radius: 10px;
            background: white;
            min-height: 88px;
            height: auto;
            font-size: 28px;
            line-height: 1.3;
            color: black;
            position: relative;
            padding: 16px 18px;
            .ku-line {
                display: flex;
                flex-wrap: wrap;
                align-items: flex-start;
                width: 100%;
                gap: 8px;
            }
            .ku-b {
                flex: 0 0 auto;
                background: #3cb371;
                color: #fff;
                border-radius: 8px;
                padding: 4px 10px;
                font-size: 22px;
                font-weight: 800;
            }
            .ku-mid {
                flex: 1;
                min-width: 0;
                text-align: left;
            }
            .ku-n {
                display: block;
                font-size: 32px;
                font-weight: 800;
                text-align: left;
                line-height: 1.25;
            }
            .ku-d {
                display: block;
                font-size: 26px;
                color: #888;
                margin-top: 4px;
                line-height: 1.3;
            }
            .ku-p {
                flex: 0 0 auto;
                align-self: flex-start;
                color: #1b8a4a;
                font-size: 32px;
                font-weight: 900;
                white-space: nowrap;
                line-height: 1.25;
            }
            label {
                display: block;
                &.ss {
                    font-size: 24px;
                    letter-spacing: 0;
                }
            }
        }

        .s2 {

        }
    }
    .ku-shop-s2 {
        font-size: 28px;
        color: #ff0;
        line-height: 100px;
        position: fixed;
        bottom: 50px;
        width: 100%;
        span {
            padding: 20px 30px;
            border-radius: 40px;
            background: #0DA195;
            margin: 0 15px;
            &:nth-child(2) {
                color: #ffffff;
            }
        }
    }
    .top {
        position: relative;
        background: white;
        display: block;
        span {
            position: absolute;
            width: 25%;
            height: 160px;
            display: block;
            top: 0;
            left: 0;
            &.s2 {
                top: auto;
                bottom: 0;
                left: 25%;
            }

        }
        .apply {
            position: absolute;
            top: 200px;//880px;
        }
    }

    .ku-home-apply {
        /* styles come from global ku-apply overlay so it matches /apply */
        position: relative;
        min-height: 100%;
    }
    .csss {
        background: none;
    }
}
</style>
